import axios from "axios";

const hostname = window.location.hostname || "127.0.0.1";
const isLocal = ["localhost", "127.0.0.1", "::1"].includes(hostname);

export default axios.create({
  baseURL: isLocal
    ? `http://${hostname}:8888/SIPT/sipt2-backend-ci/`
    : "https://api-gateway.ubpkarawang.ac.id/",
  headers: {
    Accept: "application/json",
    "Content-type": "application/json",
  },

  validateStatus: () => true,
});
